module.exports = __webpack_public_path__ + "img/hzico_7.7390122f.jpg";